module.exports = __webpack_public_path__ + "static/media/infoIcon.917a3237.svg";